/* eslint-disable no-eval */
import React from "react";
import { Form, Button } from "antd";
import { PlusCircleOutlined, DeleteOutlined, MessageOutlined } from "@ant-design/icons";
import i18next from "i18next"
import { camelCaseToTitle } from '../../helpers/StringHelper';
import {
  getFormTitles,
  getInputHeadLines,
  getInputLabel,
  getInputProp,
  getSectionLabel,
  getSubtitles,
  inputOnBlur,
  inputTypeComponent,
  showHideInput
} from "./helper";
import { RiskGroup } from "./components/riskComment";
import { checkCondition } from '../EditCADD/helper';
import dayjs from "dayjs";

const isRiskComment = (inputData) => {
  if (inputData) {
    if (inputData.name === 'assessment') {
      if (
        inputData.inputName === 'threat' ||
        inputData.inputName === 'vulnerability' ||
        inputData.inputName === 'impact'
      ) {
        return true;
      }
    }
  }
  return false;
}

// options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress
export function renderNestedInputs(options, k, ...args) {
  if (options[k].repeatable) {
    return renderRepeatable(options, k, ...args);
  } else {
    return renderGroupOfInputs(options, k, ...args);
  }
}

export function renderRepeatable(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress, onValuesChange) {
  const form = options[k];
  const formId = form.dataId || k;
  const isRisk = options.isRisk || false;
  const allInputs = Object.keys(form.inputs).filter(i => {
    const input = form.inputs[i];
    return !excludedKeys.includes(i) &&
      showHideInput(input, values, undefined, undefined, setValues, `${formId}.${i}`)
  });

  let maxRepeat = 9999;
  if (typeof options[k].maxRepeat === 'string') {
    const [maxRepeatCond, trueVal] = options[k].maxRepeat.split('|');
    if (checkCondition(maxRepeatCond, values, values)) {
      maxRepeat = parseInt(trueVal);
    }
    // const values = Array.isArray(args) && args.length > 2 ? args[1] : {};
    // options[k].repeatable = checkCondition(options[k].repeatable, values, values);
  }

  if (isRisk) {
    return allInputs.length ? <React.Fragment key={i}>
      {getFormTitles(formTitles, formId, i)}
      {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.inputType) ?
        getInputHeadLines(form.inputType, i, form, values)
        :
        <div className="risk-item-cont">
          <div className="risk-item-cont-header">
            {!form.repeatable
              ? (
                <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'}`}>
                  {getInputLabel(form, values)}
                </h3>
              ) : (!form.hideSectionLabel ? (
                <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'}`}>
                  {(form.label ? getInputLabel(form, values) : camelCaseToTitle(k))}
                </h3>
              ) : null)}
            {form.titleLabel ? <label>{getInputProp(form.titleLabel, values)}</label> : null}
          </div>
          <Form.List key={formId} name={formId}>
            {(fields, { add, remove }) => {
              const formData = form.repeatable
                ? (values[formId] || [])
                : (values[formId]
                  ? [values[formId]] : []);
              if (fields.length === 0) {
                const formInputs = form.inputs
                if (formData.length) {
                  formData.forEach(f => {
                    Object.keys(f).forEach(fkey => {
                      if (formInputs[fkey] && formInputs[fkey].inputType === 'total100' && !f[fkey]) {
                        f[fkey] = [{
                          type: null,
                          value: null
                        }];
                      } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].inputType)) {
                        f[fkey] = f[fkey] ? dayjs(f[fkey]) : undefined;
                      } else if (formInputs[fkey] && 'switch' === formInputs[fkey].inputType) {
                        f[fkey] = f[fkey] || false;
                      }
                    })
                    add(f);
                  })
                } else {
                  const fData = {};
                  Object.keys(formInputs).forEach(fkey => {
                    if (formInputs[fkey] && formInputs[fkey].inputType === 'total100') {
                      fData[fkey] = [{
                        type: null,
                        value: null
                      }];
                    } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].inputType)) {
                      fData[fkey] = fData[fkey] ? dayjs() : undefined;
                    } else if (formInputs[fkey] && 'switch' === formInputs[fkey].inputType) {
                      fData[fkey] = fData[fkey] || false;
                    }
                  })
                  add(fData);
                }
              }
              if (form.repeatable && form.editComponent) {
                try {
                  const fn = eval(form.editComponent);
                  return fn(options[k], setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
                } catch (e) {
                  return 'Edit component not found';
                }
              }
              const formInputs = Object.keys(form.inputs)
                .filter(i => !excludedKeys.includes(i));
              const totalFormInputs = formInputs.length;
              let shownInputs = {};
              return <React.Fragment>
                <div className={form.repeatable ? "repeatable mb-4" : ''}>
                  {fields.map(field => <React.Fragment key={`${formId}-${field.name}`}>
                    <div className="repeatable-item mb-1">
                      {form.repeatable ?
                        <div className="d-flex justify-content-between mb-2" style={{
                          marginTop: '-5px'
                        }}>
                          <div>
                            <h4
                              className={!isRisk ? 'title-semibold-4' : 'risk-color-blue'}
                              style={{
                                color: 'var(--color-primary-70)',
                                lineHeight: '32px',
                              }}
                            >
                              {form.sectionLabel ? getSectionLabel(form.sectionLabel, values) : null} {maxRepeat > 1 ? `#${field.name + 1}` : ''}
                            </h4>
                          </div>
                          <div className="remove-button-for-repeatable">
                            {((Array.isArray(formData) ? formData : []).filter(k => Object.keys(k).length > 0).length >= 1 || fields.length > 1) && (typeof form.canDelete !== 'function' || form.canDelete(
                              Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {})
                            ))
                              ? (
                                <Button
                                  type="link"
                                  danger
                                  onClick={() => {
                                    remove(field.name);
                                    if (fields.length === 1) {
                                      add({});
                                    }
                                  }}>
                                  <DeleteOutlined />
                                </Button>)
                              : null}
                          </div>
                        </div> : null}
                      {formInputs.map((inp, ii) => {
                        const input = form.inputs[inp];
                        const inputId = input.dataId || inp;
                        const inputValues = Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {});
                        const value = inputValues[inputId];
                        const commentValue = inputValues[`${inputId}Comment`];
                        const inputData = getData(formId, input, value, commentValue, `${formId}[${field.name}].${inputId}`, `${formId}.${inputId}`);
                        const subtitles = form.subtitles || null;
                        inputData.repeatIndex = field.name;
                        inputData.inputName = inputId;
                        inputData.repeatValues = inputValues;
                        if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
                          inputData.groupInputs = inputData.groupInputs.map(gpI => {
                            gpI.data.inputName = gpI.data.name;
                            gpI.data.repeatIndex = field.name;
                            gpI.data.name = formId;
                            return gpI;
                          });
                        }
                        inputData.totalInputs = totalFormInputs;
                        shownInputs[inputId] = showHideInput(input, values, field.name, inputValues, setValues, `${formId}[${field.name}].${inputId}`);
                        inputData.shownInputs = shownInputs
                        const rules = inputData.rules
                          ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
                          : []

                        const requiredRule = rules.find((r) => r.required);

                        if (requiredRule && input.inputType === 'text') {
                          rules.push({ whitespace: true, message: requiredRule.message || '' });
                        }

                        return shownInputs[inputId] ?
                          <React.Fragment key={`${i}${ii}`}>
                            <div key={ii} className={form.repeatable
                              ? `inputs` : ""}>
                              {getSubtitles(subtitles, input.position, values, field.name, inputValues)}
                              {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                                getInputHeadLines(input.inputType, i, input, values)
                                :
                                <>
                                  <Form.Item
                                    {...field}
                                    required={
                                      inputData.rules && inputData.rules instanceof Array &&
                                        inputData.rules.filter(r => r.required).length > 0 ? true : false
                                    }
                                    {...(['total100', 'group'].includes(input.inputType) ? {} : {
                                      name: [field.name, inputId],
                                      fieldKey: [field.fieldKey, inputId],
                                      initialValue: inputData.value,
                                    })}
                                    {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                                      valuePropName: "fileList",
                                      getValueFromEvent: (e) => {
                                        if (Array.isArray(e)) {
                                          return e;
                                        }
                                        return e && e.fileList && e.fileList.map(f => {
                                          if (f.response) {
                                            return f.response;
                                          }
                                          return f;
                                        })
                                      }
                                    } : {})}
                                    {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                                    style={input.showOnView === false ? { display: 'none' } : {}}
                                    {...(['switch'].includes(input.inputType) ? {
                                      labelCol: { span: 20 },
                                      style: {
                                        ...(input.showOnView === false ? { display: 'none' } : {}),
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                      }
                                    } : {})}
                                    label={input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
                                      <Button
                                        icon={<MessageOutlined />}
                                        {...(typeof inputData.commentValue !== 'string' ? {} : { danger: true })}
                                        disabled={inputData.props.disabled}
                                        type="link"
                                        onClick={() => {
                                          if (typeof inputData.commentValue === 'string') {
                                            onValuesChange({}, { ...values, [`${inputData.inputName}`]: null });
                                          }
                                          const inputValues = Array.isArray(values[formId])
                                            ? (values[formId][field.name] || [])
                                            : (values[formId] || []);
                                          inputValues[`${inputData.inputName}Comment`] =
                                            typeof inputData.commentValue !== 'string' ? '' : undefined;
                                          if (Array.isArray(values[formId])) {
                                            values[formId][field.name] = inputValues;
                                          } else {
                                            values[formId] = inputValues;
                                          }
                                          setValues({ ...values });
                                        }}>
                                        {i18next.t(typeof inputData.commentValue !== 'string'
                                          ? 'Add Comment' : 'Remove Comment')}
                                      </Button>
                                    </span></span> : getInputLabel(input, values)}
                                    rules={rules}
                                    className={`${input.comment ? 'with-comment' : ''} i-${input.inputType} total-inputs-${totalFormInputs}`}
                                    data-id={inputData.inputName}>
                                    {inputTypeComponent[input.inputType]
                                      ? inputTypeComponent[input.inputType]({ ...inputData, isRisk: true }, {
                                        form: MainForm,
                                        forms: options,
                                        allForms: plainForms,
                                        setFormValues: setValues,
                                        remove,
                                        add,
                                        setAddress
                                      }) : console.log(input)}
                                  </Form.Item>
                                  {input.comment ?
                                    <Form.Item
                                      className="comment-textarea"
                                      name={[field.name, `${inputData.inputName}Comment`]}
                                      fieldKey={[field.fieldKey, `${inputData.inputName}Comment`]}
                                      initialValue={inputData.commentValue}
                                      hidden={typeof inputData.commentValue !== 'string'}>
                                      {inputTypeComponent.comment(inputData, {
                                        form: MainForm,
                                        forms: options,
                                        setFormValues: setValues
                                      })}
                                    </Form.Item> : null}
                                </>
                              }
                            </div>
                          </React.Fragment> : null
                      })}
                    </div>
                  </React.Fragment>
                  )}
                  {form.repeatable && fields.length < maxRepeat ? (
                    <Button
                      type="dashed"
                      className="mt-2 test 1"
                      style={{ borderRadius: '2px' }}
                      block
                      onClick={() => add({})}>
                      <PlusCircleOutlined /> {form.repeatLabel || i18next.t('Add New')}
                    </Button>
                  ) : null}
                </div>
              </React.Fragment>
            }}
          </Form.List>
        </div>
      }
    </React.Fragment> : null
  }

  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.inputType) ?
      getInputHeadLines(form.inputType, i, form, values)
      :
      <>
        {!form.repeatable
          ? (
            <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} ${i ? 'mt-3' : ''}`}>
              {getInputLabel(form, values)}
            </h3>
          ) : (!form.hideSectionLabel ? (
            <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} ${i ? 'mt-3' : ''}`}>
              {(form.label ? getInputLabel(form, values) : camelCaseToTitle(k))}
            </h3>
          ) : null)}
        <Form.List key={formId} name={formId}>
          {(fields, { add, remove }) => {
            const formData = form.repeatable
              ? (values[formId] || [])
              : (values[formId]
                ? [values[formId]] : []);
            if (fields.length === 0) {
              const formInputs = form.inputs
              if (formData.length) {
                formData.forEach(f => {
                  Object.keys(f).forEach(fkey => {
                    if (formInputs[fkey] && formInputs[fkey].inputType === 'total100' && !f[fkey]) {
                      f[fkey] = [{
                        type: null,
                        value: null
                      }];
                    } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].inputType)) {
                      f[fkey] = f[fkey] ? dayjs(f[fkey]) : undefined;
                    } else if (formInputs[fkey] && 'switch' === formInputs[fkey].inputType) {
                      f[fkey] = f[fkey] || false;
                    }
                  })
                  add(f);
                })
              } else {
                const fData = {};
                Object.keys(formInputs).forEach(fkey => {
                  if (formInputs[fkey] && formInputs[fkey].inputType === 'total100') {
                    fData[fkey] = [{
                      type: null,
                      value: null
                    }];
                  } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].inputType)) {
                    fData[fkey] = fData[fkey] ? dayjs() : undefined;
                  } else if (formInputs[fkey] && 'switch' === formInputs[fkey].inputType) {
                    fData[fkey] = fData[fkey] || false;
                  }
                })
                add(fData);
              }
            }
            if (form.repeatable && form.editComponent) {
              try {
                const fn = eval(form.editComponent);
                return fn(options[k], setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
              } catch (e) {
                return 'Edit component not found';
              }
            }
            const formInputs = Object.keys(form.inputs)
              .filter(i => !excludedKeys.includes(i));
            const totalFormInputs = formInputs.length;
            let shownInputs = {};
            return <React.Fragment>
              <div className={form.repeatable ? "repeatable mb-4" : ''}>
                {form.titleLabel ? <label>{getInputProp(form.titleLabel, values)}</label> : null}
                {fields.map(field => <React.Fragment key={`${formId}-${field.name}`}>
                  <div className="repeatable-item mb-1">
                    {form.repeatable ?
                      <div className="d-flex justify-content-between mb-2" style={{
                        marginTop: '-5px'
                      }}>
                        <div>
                          <h4
                            className={!isRisk ? 'title-semibold-4' : 'risk-color-blue'}
                            style={{
                              color: 'var(--color-primary-70)',
                              lineHeight: '32px',
                            }}
                          >
                            {form.sectionLabel ? getSectionLabel(form.sectionLabel, values) : null} {maxRepeat > 1 ? `#${field.name + 1}` : ''}
                          </h4>
                        </div>
                        <div className="remove-button-for-repeatable">
                          {((Array.isArray(formData) ? formData : []).filter(k => Object.keys(k).length > 0).length >= 1 || fields.length > 1) && (typeof form.canDelete !== 'function' || form.canDelete(
                            Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {})
                          ))
                            ? (
                              <Button
                                type="link"
                                danger
                                onClick={() => {
                                  remove(field.name);
                                  if (fields.length === 1) {
                                    add({});
                                  }
                                }}>
                                <DeleteOutlined />
                              </Button>)
                            : null}
                        </div>
                      </div> : null}
                    {formInputs.map((inp, ii) => {
                      const input = form.inputs[inp];
                      const inputId = input.dataId || inp;
                      const inputValues = Array.isArray(values[formId]) ? (values[formId][field.name] || {}) : (values[formId] || {});
                      const value = inputValues[inputId];
                      const commentValue = inputValues[`${inputId}Comment`];
                      const inputData = getData(formId, input, value, commentValue, `${formId}[${field.name}].${inputId}`, `${formId}.${inputId}`);
                      const subtitles = form.subtitles || null;
                      inputData.repeatIndex = field.name;
                      inputData.inputName = inputId;
                      inputData.repeatValues = inputValues;
                      if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
                        inputData.groupInputs = inputData.groupInputs.map(gpI => {
                          gpI.data.inputName = gpI.data.name;
                          gpI.data.repeatIndex = field.name;
                          gpI.data.name = formId;
                          return gpI;
                        });
                      }
                      inputData.totalInputs = totalFormInputs;
                      shownInputs[inputId] = showHideInput(input, values, field.name, inputValues, setValues, `${formId}[${field.name}].${inputId}`);
                      inputData.shownInputs = shownInputs


                      const rules = inputData.rules
                        ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
                        : []

                      const requiredRule = rules.find((r) => r.required);

                      if (requiredRule && input.inputType === 'text') {
                        rules.push({ whitespace: true, message: requiredRule.message || '' });
                      }

                      return shownInputs[inputId] ?
                        <React.Fragment key={`${i}${ii}`}>
                          <div key={ii} className={form.repeatable
                            ? `inputs` : ""}>
                            {getSubtitles(subtitles, input.position, values, field.name, inputValues)}
                            {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                              getInputHeadLines(input.inputType, i, input, values)
                              :
                              <>
                                <Form.Item
                                  {...field}
                                  required={
                                    inputData.rules && inputData.rules instanceof Array &&
                                      inputData.rules.filter(r => r.required).length > 0 ? true : false
                                  }
                                  {...(['total100', 'group'].includes(input.inputType) ? {} : {
                                    name: [field.name, inputId],
                                    fieldKey: [field.fieldKey, inputId],
                                    initialValue: inputData.value,
                                  })}
                                  {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                                    valuePropName: "fileList",
                                    getValueFromEvent: (e) => {
                                      if (Array.isArray(e)) {
                                        return e;
                                      }
                                      return e && e.fileList && e.fileList.map(f => {
                                        if (f.response) {
                                          return f.response;
                                        }
                                        return f;
                                      })
                                    }
                                  } : {})}
                                  {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                                  style={input.showOnView === false ? { display: 'none' } : {}}
                                  {...(['switch'].includes(input.inputType) ? {
                                    labelCol: { span: 20 },
                                    style: {
                                      ...(input.showOnView === false ? { display: 'none' } : {}),
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                    }
                                  } : {})}
                                  label={input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
                                    <Button
                                      icon={<MessageOutlined />}
                                      {...(typeof inputData.commentValue !== 'string' ? {} : { danger: true })}
                                      disabled={inputData.props.disabled}
                                      type="link"
                                      onClick={() => {
                                        if (typeof inputData.commentValue === 'string') {
                                          onValuesChange({}, { ...values, [`${inputData.inputName}`]: null });
                                        }
                                        const inputValues = Array.isArray(values[formId])
                                          ? (values[formId][field.name] || [])
                                          : (values[formId] || []);
                                        inputValues[`${inputData.inputName}Comment`] =
                                          typeof inputData.commentValue !== 'string' ? '' : undefined;
                                        if (Array.isArray(values[formId])) {
                                          values[formId][field.name] = inputValues;
                                        } else {
                                          values[formId] = inputValues;
                                        }
                                        setValues({ ...values });
                                      }}>
                                      {i18next.t(typeof inputData.commentValue !== 'string'
                                        ? 'Add Comment' : 'Remove Comment')}
                                    </Button>
                                  </span></span> : getInputLabel(input, values)}
                                  rules={rules}
                                  className={`${input.comment ? 'with-comment' : ''} i-${input.inputType} total-inputs-${totalFormInputs}`}
                                  data-id={inputData.inputName}>
                                  {inputTypeComponent[input.inputType]
                                    ? inputTypeComponent[input.inputType](inputData, {
                                      form: MainForm,
                                      forms: options,
                                      allForms: plainForms,
                                      setFormValues: setValues,
                                      remove,
                                      add,
                                      setAddress
                                    }) : console.log(input)}
                                </Form.Item>
                                {input.comment ?
                                  <Form.Item
                                    className="comment-textarea"
                                    name={[field.name, `${inputData.inputName}Comment`]}
                                    fieldKey={[field.fieldKey, `${inputData.inputName}Comment`]}
                                    initialValue={inputData.commentValue}
                                    hidden={typeof inputData.commentValue !== 'string'}>
                                    {inputTypeComponent.comment(inputData, {
                                      form: MainForm,
                                      forms: options,
                                      setFormValues: setValues
                                    })}
                                  </Form.Item> : null}
                              </>
                            }
                          </div>
                        </React.Fragment> : null
                    })}
                  </div>
                </React.Fragment>
                )} {form.repeatable && fields.length < maxRepeat
                  ? (
                    <Button
                      type="dashed"
                      className="mt-2"
                      style={{ borderRadius: '2px' }}
                      block
                      onClick={() => add({})}>
                      <PlusCircleOutlined />
                      {getSectionLabel(form.repeatLabel, values)}
                    </Button>
                  ) : null}
              </div>
            </React.Fragment>
          }}
        </Form.List>
      </>
    }
  </React.Fragment> : null

}

export function renderGroupOfInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress, onValuesChange, empty, allData) {
  const form = options[k];
  const formId = form.dataId || k;
  const allInputs = Object.keys(form.inputs).filter(i => !excludedKeys.includes(i));
  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.inputType) ?
      getInputHeadLines(form.inputType, i, form, values)
      :
      getGroupContent(form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress, onValuesChange, allData)
    }
  </React.Fragment> : null
}

const getGroupContent = (form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress, onValuesChange, allData) => {
  const label = getInputLabel(form, values);
  const hasLabel = label && ((typeof label === 'string' && (label || '').trim() !== '') || typeof label === 'object') ? true : false;
  return <>
    {hasLabel ? (options.isRisk && options.dontShowTitle) ? (
      <div className="risk-header">
        <h1>
          {label}
        </h1>
      </div>
    ) : (
      <h3 className={`${form.titleClass ? form.titleClass : 'title-semibold-4'} ${i ? 'mt-3 mb-1' : ''}`}>
        {label}
      </h3>
    ) : null}
    <div className={`repeatable ${hasLabel ? "mb-4" : ""}`}>
      {form.titleLabel ? <label>{getInputProp(form.titleLabel, values)}</label> : null}
      {Object.keys(form.inputs)
        .filter(i => !excludedKeys.includes(i))
        .map((inp, ii) => {
          const input = form.inputs[inp];
          const inputId = input.dataId || inp;
          const inputValues = Array.isArray(values[formId]) ? (values[formId] || {}) : (values[formId] || {});
          const value = inputValues[inputId];
          const commentValue = inputValues[`${inputId}Comment`];
          const inputData = getData(formId, input, value, commentValue, `${formId}.${inputId}`, `${formId}.${inputId}`);
          const subtitles = form.subtitles || null;
          inputData.repeatIndex = undefined;
          inputData.inputName = inputId;
          inputData.repeatValues = inputValues;
          if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
            inputData.groupInputs = inputData.groupInputs.map(gpI => {
              gpI.data.inputName = gpI.data.name;
              gpI.data.repeatIndex = undefined;
              gpI.data.name = formId;
              return gpI;
            });
          }
          const isRisk = isRiskComment(inputData);

          const btnOnClick = () => {
            if (typeof inputData.commentValue === 'string') {
              onValuesChange({}, { ...values, [`${inputData.inputName}`]: null });
            }
            const inputValues = Array.isArray(values[formId])
              ? (values[formId] || {})
              : (values[formId] || {});
            inputValues[`${inputData.inputName}Comment`] =
              typeof inputData.commentValue !== 'string' ? '' : null;
            if (Array.isArray(values[formId])) {
              values[formId] = inputValues;
            } else {
              values[formId] = inputValues;
            }
            setValues({ ...values });
          }

          const btnOnClick2 = () => {
            if (typeof inputData.commentValue !== 'string') {
              const inputValues = Array.isArray(values[formId])
                ? (values[formId] || {})
                : (values[formId] || {});
              inputValues[`${inputData.inputName}Comment`] =
                typeof inputData.commentValue !== 'string' ? '' : null;
              if (Array.isArray(values[formId])) {
                values[formId] = inputValues;
              } else {
                values[formId] = inputValues;
              }
              setValues({ ...values });
            }
          };

          const rules = inputData.rules
            ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
            : []

          const requiredRule = rules.find((r) => r.required);

          if (requiredRule && input.inputType === 'text') {
            rules.push({ whitespace: true, message: requiredRule.message || '' });
          }

          return showHideInput(input, values, undefined, inputValues, setValues, `${formId}.${inputId}`) ?
            <React.Fragment key={`${i}${ii}`}>
              <div key={ii} style={{ position: 'relative' }}>
                {getSubtitles(subtitles, input.position, values, undefined, inputValues)}
                {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                  getInputHeadLines(input.inputType, i, input, values)
                  :
                  isRisk ? <RiskGroup
                    input={input}
                    inputTypeComponent={inputTypeComponent}
                    inputData={inputData}
                    MainForm={MainForm}
                    options={options}
                    setValues={setValues}
                    formId={formId}
                    inputId={inputId}
                    inputOnBlur={inputOnBlur}
                    values={values}
                    getInputLabel={getInputLabel}
                    plainForms={plainForms}
                    setAddress={setAddress}
                    btnOnClick={btnOnClick}
                    btnOnClick2={btnOnClick2}
                    locationName={(allData || {}).locationName}
                    subGroupTitle={(allData || {}).subGroupTitle}
                  /> :
                    <>
                      <Form.Item
                        required={
                          inputData.rules && inputData.rules instanceof Array &&
                            inputData.rules.filter(r => r.required).length > 0 ? true : false
                        }
                        {...(['total100', 'group'].includes(input.inputType) ? {} : {
                          name: [formId, inputId],
                          fieldKey: [formId, inputId],
                          initialValue: inputData.value,
                        })}
                        {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                          valuePropName: "fileList",
                          getValueFromEvent: (e) => {
                            if (Array.isArray(e)) {
                              return e;
                            }
                            return e && e.fileList && e.fileList.map(f => {
                              if (f.response) {
                                return f.response;
                              }
                              return f;
                            })
                          }
                        } : {})}
                        {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                        style={input.showOnView === false ? { display: 'none' } : {}}
                        {...(['switch'].includes(input.inputType) ? {
                          labelCol: { span: 20 },
                          style: {
                            ...(input.showOnView === false ? { display: 'none' } : {}),
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                          }
                        } : {})}
                        label={input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
                          <Button
                            icon={<MessageOutlined />}
                            {...(typeof inputData.commentValue !== 'string' ? {} : { danger: true })}
                            disabled={inputData.props.disabled}
                            type="link"
                            onClick={btnOnClick}>
                            {isRisk ? i18next.t('Comments') :
                              i18next.t(typeof inputData.commentValue !== 'string'
                                ? 'Add Comment' : 'Remove Comment')
                            }
                          </Button>
                        </span></span> : getInputLabel(input, values)}
                        rules={rules}
                        className={input.comment ? `with-comment i-${input.inputType}` : `i-${input.inputType}`}
                        data-id={inputData.inputName}>
                        {inputTypeComponent[input.inputType]
                          ? inputTypeComponent[input.inputType](inputData, {
                            form: MainForm,
                            forms: options,
                            allForms: plainForms,
                            setFormValues: setValues,
                            setAddress,
                          }) : console.log(input)}
                      </Form.Item>
                      {(input.comment) ?
                        <Form.Item
                          className="comment-textarea"
                          name={[formId, `${inputData.inputName}Comment`]}
                          fieldKey={[formId, `${inputData.inputName}Comment`]}
                          initialValue={inputData.commentValue}
                          hidden={typeof inputData.commentValue !== 'string'}>
                          {inputTypeComponent.comment(inputData, {
                            form: MainForm,
                            forms: options,
                            setFormValues: setValues
                          })}
                        </Form.Item> : null}
                    </>
                }
              </div>
            </React.Fragment> : null
        })}
    </div>
  </>
}
